import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "./utils.js";
export const buttonVariants = cva("inline-flex items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition-[background-color,color,border-color,box-shadow,transform] outline-none select-none disabled:pointer-events-none disabled:opacity-50 active:translate-y-px", {
    variants: {
        size: {
            // Controls grow to a 44 px touch target below desktop width.
            default: "h-10 max-lg:h-11",
            icon: "size-10 px-0 max-lg:size-11",
            sm: "h-8 rounded-lg px-3 text-xs max-lg:h-11",
        },
        variant: {
            default: "bg-emerald-800 text-white shadow-sm hover:bg-emerald-900 hover:shadow-md",
            destructive: "bg-red-700 text-white hover:bg-red-800",
            ghost: "text-stone-600 hover:bg-stone-100 hover:text-stone-950",
            outline: "border border-stone-300 bg-surface text-stone-800 shadow-xs hover:border-emerald-700 hover:text-emerald-900",
        },
    },
    defaultVariants: { size: "default", variant: "default" },
});
export function Button({ className, size, type = "button", variant, ...props }) {
    return (_jsx("button", { className: cn(buttonVariants({ className, size, variant })), type: type, ...props }));
}
